module.exports = __webpack_public_path__ + "static/media/live_your_best_life_l.3f61c2d5.png";